import React from "react"
import { default as TableComponent } from "@app/components/Table"
import { Container } from "@chakra-ui/react"

const Table = ({ table: tableContent }) => {
  return (
    <Container w={["unset", "648px"]} minW={"unset"} p={["0px", "0px"]}>
      <TableComponent table={tableContent} />
    </Container>
  )
}

export default React.memo(Table)
